"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Separator = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../utils/classFunctions");
require("./index.scss");
const className = 'separator';
const Separator = (props) => {
    const { modificators, horizontal } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        modificators,
        horizontal ? 'horizontal' : undefined,
    ]);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", null)));
};
exports.Separator = Separator;
//# sourceMappingURL=index.js.map